import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";

const Spacer = styled.div`
  height: ${(props) => (props.xl && "70px") || (props.xs && "15px") || "30px"};
  ${breakpoints.xsDown} {
    height: 20px;
    height: ${(props) => props.xl && "40px"};
  }
`;

export default Spacer;
